import { el } from 'redom';

class TimeInput {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    this.el = el('.time-input-main', [
      el('input.time-input.date-input', {
        disabled: configuration.disabled,
        type: 'time',
        placeholder: configuration.placeholder,
        value: configuration.value,
        onclick: this.handleClick.bind(this),
        onchange: this.handleChange.bind(this)
      })
    ]);

  }

  handleClick(event) {

    event.stopPropagation();
    event.target.showPicker();

  }

  handleChange(event) {

    const value = event.target.value;

    this.onChange(event, value);

  }

  setValue(value) {

    this.el.querySelector('input').value = value;

  }

  getValue() {

    return this.el.querySelector('input').value;

  }

  getValueAsNumber() {

    return this.el.querySelector('input').valueAsNumber;

  }

  focus() {

    this.el.querySelector('input').focus();

  }

}

export default TimeInput;